import React from "react";
import { ArrowDownRight } from "react-feather";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody, Progress } from "reactstrap";
import avatar from "../../../assets/images/avatar.png";
import RadialProgressChart from "./RadialProgressChart";

const YourBalanceCard = ({
  userImage,
  userName,
  userLocation,
  radialData,
  profileCompletionPercentage,
  visitorCount,
}) => {
  return (
    <Card className="balance-box">
      <CardBody>
        <div className="balance-profile">
          <div className="balance-img">
            {userImage ? (
              <img src={userImage} alt="user vector" width="64" height="64" />
            ) : (
              <img src={avatar} alt="default user" width="64" height="64" />
            )}
            {/* <Link
      className="edit-icon"
      to={`${process.env.PUBLIC_URL}/app/users/profile`}
    >
      <SvgIcon iconId="pencil" />
    </Link> */}
          </div>
          <h5>{userName}</h5>
          <span className="f-light d-block mt-1">{userLocation}</span>
        </div>

        <div className="progress-showcase row mt-3">
          <div className="col-12 text-right mb-2">
            <Progress
              value={profileCompletionPercentage}
              color="info"
              className="sm-progress-bar"
            />
          </div>
          <div className="col-12 d-flex justify-content-between">
            <div>{profileCompletionPercentage}% profile completed</div>
            <div>Finish Profile</div>
          </div>
        </div>
        {/* <div className="radial-progress-card ">
          {radialData.map((item, i) => (
            <Col key={i} xl="12" sm="6" className="radial-chart-wrap">
              <RadialProgressChart chartHeight={150} chartOption={item} />
              <div className="chart-title">{item.title}</div>
            </Col>
          ))}
        </div> */}
        <div className="radial-progress-card ">
          <Col
            xl="12"
            sm="6"
            className="d-flex justify-content-around align-items-center "
          >
            <div className="text-center">
              <h4>{visitorCount ? visitorCount : 0}</h4>
              <span className="f-light">Visitors</span>
            </div>
            <div className="text-center">
              <h4>{visitorCount ? visitorCount : 0}</h4>
              <span className="f-light">Visitors</span>
            </div>
            <div className="text-center">
              <h4>{visitorCount ? visitorCount : 0}</h4>
              <span className="f-light">Visitors</span>
            </div>
          </Col>
        </div>
      </CardBody>
    </Card>
  );
};

export default YourBalanceCard;
